import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PREPAIDACCOUNTTOPUPMODAL_LEGACY_FIELD_ORDER = [
  "free_amount_button_position",
  "description"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  prepaidAccountTopUpModalDescriptor: _generatedPrepaidAccountTopUpModalDescriptor,
  prepaidAccountTopUpModalModalDefinition,
  prepaidAccountTopUpModalDashboardLayout,
  prepaidAccountTopUpModalConfig,
  prepaidAccountTopUpModalResolveConfig,
  prepaidAccountTopUpModalProperties,
} = doodModalConfig(
  {
    name: "PrepaidAccountTopUpModal",
    handle: "prepaid-account-top-up-modal",
    internal_name: "PrepaidAccountTopUpModal",
    componentType: 'PrepaidAccountTopUpModalComponent',
    category: 'modal',
    description: "PrepaidAccountTopUpModal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "prepaid-account-top-up-modal",
    sharedFields: {}
  },

  () => ({
    free_amount_button_position: propertyValue({
      type: 'select',
      value: "first",
      options: {
        "label": "Free amount button position",
        "help": "Emplacement du bouton \"montant libre\" par rapport aux montants pré-sélectionnés",
        "choices": [
          {
            "value": "first",
            "label": "Avant les montants pré-sélectionnés"
          },
          {
            "value": "last",
            "label": "Après les montants pré-sélectionnés"
          },
          {
            "value": "hidden",
            "label": "Masqué"
          }
        ]
      }
    }),
    description: propertyValue({
      type: 'translation',
      value: '',
      options: {
        "label": "Texte descriptif",
        "help": "Texte affiché sous le titre de la modal (ex. \"-10% à partir de 100€\")",
        "multiline": true,
        "rows": 3
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["free_amount_button_position", "description"],
          },
        ],
      },
    ],
  })
);

export function prepaidAccountTopUpModalDescriptor(): IBlockDescriptor;
export function prepaidAccountTopUpModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function prepaidAccountTopUpModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPrepaidAccountTopUpModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPrepaidAccountTopUpModalDescriptor, prepaidAccountTopUpModalProperties, fieldOrder);
}

export {
  prepaidAccountTopUpModalModalDefinition,
  prepaidAccountTopUpModalDashboardLayout,
  prepaidAccountTopUpModalProperties,
  prepaidAccountTopUpModalConfig,
  prepaidAccountTopUpModalResolveConfig,
};

export type PrepaidAccountTopUpModalConfig = typeof prepaidAccountTopUpModalConfig;
